import { addPolygonRange } from 'Pods/SearchPage/Store/actions/polygon'
import { setAnimated, setPbr, setRigged } from 'Pods/SearchPage/Store/actions/threeDOnly'
import { setThreeDPrintVerified } from 'Pods/SearchPage/Store/actions/threeDPrintOnly'
import { ASSET_TYPE, POLYGON_RANGE } from 'Pods/SearchPage/Store/constants'

// The brief's list (ClickUp 124g39pctu5, decision 4). Valentyna's design shows Simulation-ready in
// place of 3D print verified while Edvardas decides. `subRowChipId` is the matching chip in the
// type sub-row, which takes focus once the shortcut has switched the type.
export const SHORTCUTS = [
  {
    key: 'low_poly',
    assetType: ASSET_TYPE.THREE_D_ONLY,
    labelKey: 'search_page.filters.technical_attributes.low_poly',
    subRowChipId: 'technical-attr-low_poly',
    apply: () => addPolygonRange(POLYGON_RANGE.LOW_POLY),
  },
  {
    key: 'rigged',
    assetType: ASSET_TYPE.THREE_D_ONLY,
    labelKey: 'search_page.filters.technical_attributes.rigged',
    subRowChipId: 'technical-attr-rigged',
    apply: () => setRigged(true),
  },
  {
    key: 'animated',
    assetType: ASSET_TYPE.THREE_D_ONLY,
    labelKey: 'search_page.filters.technical_attributes.animated',
    subRowChipId: 'technical-attr-animated',
    apply: () => setAnimated(true),
  },
  {
    key: 'pbr',
    assetType: ASSET_TYPE.THREE_D_ONLY,
    labelKey: 'search_page.filters.technical_attributes.pbr',
    subRowChipId: 'technical-attr-pbr',
    apply: () => setPbr(true),
  },
  {
    key: 'three_d_print_verified',
    assetType: ASSET_TYPE.THREE_D_PRINT_ONLY,
    labelKey: 'search_page.filters.print_attributes.three_d_print_verified',
    subRowChipId: 'print-attr-three_d_print_verified',
    apply: () => setThreeDPrintVerified(true),
    // Figma 3217:85369 (640) keeps only the 3D shortcuts in the row.
    isHiddenAtSm: true,
  },
]
